import React from 'react';

interface CaptionOverlayProps {
  text: string;
}

export const CaptionOverlay = React.memo(function CaptionOverlay({ text }: CaptionOverlayProps) {
  if (!text) return null;

  return (
    <div className="kollab-player-caption-container">
      <div
        className="kollab-player-caption-overlay"
        aria-live="polite"
        aria-atomic="true"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
});
